/**
 * A Vue.js directive that ensures a numeric input field is set to zero if it
 * is empty or null when it loses focus.
 *
 * @module zero-if-empty
 *
 * @example
 * <input v-zero-if-empty="{ object: myObject, key: 'myKey' }">
 *
 * @description
 * This directive listens for the 'input' event on the element and sets the
 * specified key in the provided object to zero if the value is empty or null
 * when the input field loses focus.
 *
 * @param {HTMLElement} el - The element to which the directive is bound.
 * @param {Object} binding - The directive binding object containing the value.
 */
export default {
  bind (el, binding, vnode) {
    const component = vnode.componentInstance

    if (!component || !binding.value) {
      return
    }

    const { object, key } = binding.value

    component.$on('blur', () => {
      const value = object[key]
      if (value === '' || value === null) {
        vnode.context.$set(object, key, 0)
      }
    })
  }
}